<template>
  <div class="vendor-summary">
    <h2 class="headline">Vendor: {{ summary.name }}</h2>
    <h3 class="subtitle-1 colorNeutralsNavy300--text">
      DETAILS
    </h3>
    <v-row>
      <v-col cols="12" md="6" lg="5" :xl="xl" class="pb-0 pb-md-3">
        <vendor-summary-property label="Vendor Number">
          <text-and-hovertext
            :text="vendorNumbers"
            :truncate-width="28"
          ></text-and-hovertext>
        </vendor-summary-property>
        <vendor-summary-property label="Signup Code">
          {{ summary.signupCode }}
        </vendor-summary-property>
        <vendor-summary-property label="Vendor Email">
          {{ summary.vendorEmail }}
        </vendor-summary-property>
      </v-col>
      <v-col cols="12" md="6" lg="5" :xl="xl" class="pt-0 pt-md-3">
        <vendor-summary-property label="Created By">
          {{ summary.creatorName }}
        </vendor-summary-property>
        <vendor-summary-property label="Creation Date">
          {{ summary.creationDate | formatDate("LL") }}
        </vendor-summary-property>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { get } from "@/services/request";
import { workflowVendorSummaryAPI } from "@/services/api";
import { formatDate } from "@/services/format";
import VendorSummaryProperty from "@/views/client/VendorSummaryProperty.vue";
import TextAndHovertext from "@/components/TextAndHovertext.vue";

export default {
  name: "WorkflowVendorSummary",
  components: { TextAndHovertext, VendorSummaryProperty },
  props: ["covgId", "covgSummary", "fluid"],
  data() {
    return {
      summary: {}
    };
  },
  computed: {
    vendorNumbers() {
      if (this.summary.vendorNumbers && this.summary.vendorNumbers.length > 0)
        return this.summary.vendorNumbers.join(", ");
      else return "Not Assigned";
    },
    xl() {
      return this.fluid ? 4 : 5;
    }
  },
  created() {
    if (this.covgSummary) {
      this.summary = this.covgSummary;
    } else {
      this.loadSummary();
    }
  },
  filters: {
    formatDate
  },
  methods: {
    formatDate,
    loadSummary() {
      get(workflowVendorSummaryAPI.getUrl({ covgId: this.covgId })).then(
        response => {
          if (response && response.data) {
            this.summary = response.data;
          }
        }
      );
    }
  }
};
</script>

<style scoped lang="scss"></style>
